<template>
    <div class="DshBtnModal">
        <dsh-buttons
            :list="$getOperationList(['set'])"
            @click="$dispatchEvent($event)"
        ></dsh-buttons>

        <div v-if="showModal">
            <dsh-modal
                v-model="showModal"
                :mode="selfModalPropsObj.mode"
                :propsObj="selfModalPropsObj"
            >
                <div style="margin: 10px 30px;">
                    <slot></slot>
                </div>
            </dsh-modal>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DshBtnModal",
        props: {
            modalPropsObj: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {
                showModal: false,
                operationMap: {
                    set: {
                        name: "设置默认内容",
                        type: "set",
                        btnType: "dashed",
                        size: "default",
                        long: true,
                        event: "clickSet"
                    }
                }
            };
        },
        computed: {
            selfModalPropsObj () {
                return {
                    mode: "middle",
                    ...this.modalPropsObj
                };
            }
        },
        created () {},
        methods: {
            // 点击设置按钮
            clickSet (operationItem) {
                this.showModal = true;
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshBtnModal {

    }
</style>
<style lang="less">
    .DshBtnModal {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/other/DshBtnModal.vue